"use client";
import { Properties } from "@/utils/properties";
import { Button } from '@/components/ui/button'
// import { Link } from 'lucide-react';
import Link from "next/link";
import { FaExclamationCircle } from "react-icons/fa";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <div className="flex min-h-[28rem] w-full flex-col items-center justify-center">
      <div className="flex w-fit flex-col items-center gap-4">
        <FaExclamationCircle className="mx-3 h-16 w-16 text-red-700" />
        <div className="flex flex-col items-center justify-center gap-2">
          <h1 className="text-4xl font-bold text-red-700">
            Something went wrong
          </h1>
          <div className=" w-fit">
            <span className="font-bold text-slate-500">Message: </span>
            <span className="text-slate-500">{error.message}</span>
          </div>
        </div>
      </div>
      <Link
        href={Properties.routes.PRODUCT_LIST}
        className="mt-5 font-semibold text-blue-500 transition-colors duration-200 hover:text-blue-700"
      >
        Go back to products
      </Link>
      <Button onClick={reset} className="mt-5">
        Retry
      </Button>
    </div>
  );
}
